package com.ijoin.ui.components

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.background
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.ui.graphics.Color
import com.ijoin.getPlatform
import com.ijoin.platform.isWebMobile

@Composable
fun NavigationScaffold(
    selectedTab: String,
    onTabSelected: (String) -> Unit,
    modifier: Modifier = Modifier,
    showAppStoreLinks: Boolean = true,
    desktopContentWidthFraction: Float = 0.6f,
    containerColor: Color = MaterialTheme.colorScheme.background,
    topBar: @Composable () -> Unit = {},
    snackbarHost: @Composable () -> Unit = {},
    content: @Composable (PaddingValues) -> Unit
) {
    val platform = remember { getPlatform() }
    val isDesktopWeb = platform.isWeb && !isWebMobile()

    if (isDesktopWeb) {
        Row(modifier = modifier.fillMaxSize()) {
            SideNavigationRail(
                selectedTab = selectedTab,
                onTabSelected = onTabSelected,
                showAppStoreLinks = showAppStoreLinks
            )

            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(containerColor),
                contentAlignment = Alignment.TopCenter
            ) {
                Box(modifier = Modifier.fillMaxWidth(desktopContentWidthFraction)) {
                    Scaffold(
                        modifier = Modifier.fillMaxSize(),
                        topBar = topBar,
                        snackbarHost = snackbarHost,
                        containerColor = containerColor,
                        content = content
                    )
                }
            }
        }
    } else {
        Scaffold(
            modifier = modifier.fillMaxSize(),
            topBar = topBar,
            snackbarHost = snackbarHost,
            containerColor = containerColor,
            bottomBar = {
                MainBottomNavigationBar(
                    selectedTab = selectedTab,
                    onTabSelected = onTabSelected
                )
            },
            content = content
        )
    }
}
